import { render, staticRenderFns } from "./SalesItem.vue?vue&type=template&id=94326a64&scoped=true&lang=pug&"
import script from "./SalesItem.vue?vue&type=script&lang=ts&"
export * from "./SalesItem.vue?vue&type=script&lang=ts&"
import style0 from "./SalesItem.vue?vue&type=style&index=0&id=94326a64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94326a64",
  null
  
)

export default component.exports